import React, { useEffect, useState, useRef } from "react";
import ForceGraph3D from "react-force-graph-3d";
import { motion } from "framer-motion";
import classes from "./Test.module.css";

const Test = () => {
  const [graphData, setGraphData] = useState({ nodes: [], links: [] });
  const [nodeCount, setNodeCount] = useState(1000);
  const [fps, setFps] = useState(0);
  const lastFrameRef = useRef(performance.now());
  const framesRef = useRef(0);

  // Generate graph
  const generateGraph = (N) => {
    const nodes = [...Array(N).keys()].map((i) => ({ id: i }));
    const links = [...Array(N * 1.5).keys()].map(() => ({
      source: Math.floor(Math.random() * N),
      target: Math.floor(Math.random() * N)
    }));
    return { nodes, links };
  };

  useEffect(() => {
    setGraphData(generateGraph(nodeCount));
  }, [nodeCount]);

  // FPS counter
  useEffect(() => {
    const measure = () => {
      framesRef.current++;
      const now = performance.now();
      if (now - lastFrameRef.current >= 1000) {
        setFps(framesRef.current);
        framesRef.current = 0;
        lastFrameRef.current = now;
      }
      requestAnimationFrame(measure);
    };
    const id = requestAnimationFrame(measure);
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <div className={classes.container}>
      <motion.div
        className={classes.controls}
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h3>Graph Stress Test</h3>
        <p>
          Nodes: <strong>{nodeCount}</strong> | FPS: <strong>{fps}</strong>
        </p>
        <input
          type="range"
          min="100"
          max="3000"
          step="100"
          value={nodeCount}
          onChange={(e) => setNodeCount(Number(e.target.value))}
        />
      </motion.div>

      <ForceGraph3D
        graphData={graphData}
        nodeAutoColorBy="id"
        nodeRelSize={3}
        linkWidth={0.5}
        linkOpacity={0.25}
        showNavInfo={false}
        enableNodeDrag={false}
        warmupTicks={30}
        cooldownTicks={150}
      />
    </div>
  );
};

export default Test;
